// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 577) return "static/chunks/lib-dist-c7eb3f57f0f4a4c0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"716":"4eee9d186087652d","991":"7f46d4340475b028"}[chunkId] + ".js";
};